import React from 'react';

import StatusBox from 'components/StatusBox';
import ButtonDropdown from 'components/ButtonDropdown';
import ExternalLink from 'components/ExternalLink';

import {formatDate} from 'utils/datetime';

import {SCHEDULE_TYPES} from 'ducks/tenancy';

import ArrowDelimiter from './assets/enlarge-horizontal.svg';
import './styles.css';

const BaseInformation = ({
  invoice,
  scheduleType,
  voidInvoice,
  addXeroIdToInvoice,
  syncInvoiceWithXero,
  openCreateCreditNoteModal,
  initiateGocardlessPayment,
  deallocateCreditNotes,
  canBeDeallocated
}) => (
  <div className="BaseInformation">
    <div className="data">
      <div className="section">
        <div className="header">To</div>
        <div className="text">{invoice.tenant.fullName}</div>
      </div>
      <div className="section">
        <div className="header">Date</div>
        <div className="text">{formatDate(invoice.date)}</div>
      </div>

      <div className="section">
        <div className="header">Due Date</div>
        <div className="text">{formatDate(invoice.dueDate)}</div>
      </div>

      <div className="section">
        <div className="header">Invoice NO</div>
        <div className="text">{invoice.idString}</div>
      </div>

      <div className="section">
        <div className="header">Account</div>
        <div className="text">{`${invoice.xeroAccount.code} - ${
          invoice.xeroAccount.name
        }`}</div>
      </div>

      <div className="section">
        <div className="header">Xero invoice</div>
        <div className="text">
          {invoice.xeroId ? (
            <ExternalLink
              className="xeroLink"
              href={invoice.xeroLink}
              targetBlank>
              {invoice.xeroNumber} →
            </ExternalLink>
          ) : (
            <StatusBox color={StatusBox.RED} status="Not synced" />
          )}
        </div>
      </div>

      {scheduleType === SCHEDULE_TYPES.RENT && (
        <div className="section">
          <div className="header">Rent Period</div>
          <div className="text rentPeriod">
            <div>{formatDate(invoice.rentStart)}</div>
            <img src={ArrowDelimiter} alt="Arrow delimiter" />
            <div>{formatDate(invoice.rentEnd)}</div>
          </div>
        </div>
      )}
    </div>

    <div className="options">
      <ButtonDropdown
        title="Invoice options"
        menuPosition={ButtonDropdown.MENU_POSITION_BOTTOM}>
        <ButtonDropdown.Option
          onClick={openCreateCreditNoteModal}
          disabled={!invoice.isCreateCreditNotePossible}>
          Create Credit Note
        </ButtonDropdown.Option>
        <ButtonDropdown.Option
          onClick={deallocateCreditNotes}
          disabled={canBeDeallocated}>
          Deallocate Credit Notes
        </ButtonDropdown.Option>
        <ButtonDropdown.Option
          disabled={!invoice.isInitiateGocardlessPaymentPossible}
          onClick={initiateGocardlessPayment}>
          Initiate GC payment
        </ButtonDropdown.Option>
        <ButtonDropdown.Option
          disabled={!invoice.isVoidable}
          onClick={voidInvoice}>
          Void
        </ButtonDropdown.Option>
        <ButtonDropdown.Option
          disabled={!invoice.isSyncable}
          onClick={syncInvoiceWithXero}>
          Sync with Xero
        </ButtonDropdown.Option>
        <ButtonDropdown.Option
          disabled={invoice.xeroId}
          onClick={addXeroIdToInvoice}>
          Add Xero ID
        </ButtonDropdown.Option>
      </ButtonDropdown>
    </div>
  </div>
);

export default BaseInformation;
